import './LoginPanel.scss';
import NP, {EventKeyArgs} from "../NP";
import Control from "../Control";
import TextField from "../Controls/TextField/TextField";
import Label from "../Controls/Label/Label";
import Button from "../Controls/Button/Button";
import TopAppBar from "../Controls/TopAppBar/TopAppBar";
import ResetPasswordDialog from "./ResetPasswordDialog";


// @ts-ignore
let S = require('string');

export default class LoginPanel extends Control {

	private _ReturnURL: string;
	private _form: HTMLElement;
	private _formContainer: HTMLElement;
	private _battleLogo: HTMLElement;
	private _emailInput: TextField;
	private _passwordInput: TextField;
	private _errorLbl: Label;
	private _topAppBar: TopAppBar;
	private _lbl: Label;
	private _forgotPasswordBtn: Button;
	private _btnDone: Button;

	private _request: XMLHttpRequest;

	constructor(settings: object)
	{
		super(settings);
		this._render();
	}

	_initFields(settings: object)
	{
		this._ReturnURL = "";
		super._initFields(settings);
	}

	_render()
	{
		this.np_render();
		this.addClass('register-panel login-panel');
		this._topAppBar = new TopAppBar({
			// Logo: {Img: '/img/logo_full.svg'},
			ParentNode: this._root,
			RightItems: [
				//	new Button({RK: 'SignUp2', EvClick: () => NP.loadTo('register')})
			],
		});

		this._battleLogo = NP.createNode(this._root, 'battle-logo', 'img');
		this._battleLogo.setAttribute('src', '/static/img/logo.png');

		this._formContainer = NP.createNode(this._root, 'register-panel__form-container register-panel__form-container--login');

		this._form = NP.createNode(this._formContainer, 'register-panel__form');

		this._lbl = new Label({
			ParentNode: this._form,
			RK: 'SignIn',
			Class: 'mdc-typography--headline6'
		});

		this._emailInput = new TextField({
			Placeholder: NP.RM.getString('Email'),
			FontImage: NP.FontImages.mail_outline,
			ParentNode: this._form,
			EvKeyDown: (s: Control, e: EventKeyArgs) =>
			{
				if (e.Event.keyCode == NP.Key.Enter && this._passwordInput.getValue())
					this._onSimpleReg();
			}
		});

		this._passwordInput = new TextField({
			Placeholder: NP.RM.getString('Password'),
			FontImage: NP.FontImages.lock,
			ParentNode: this._form,
			IsPassword: true,
			EvKeyDown: (s: Control, e: EventKeyArgs) =>
			{
				if (e.Event.keyCode == NP.Key.Enter)
					this._onSimpleReg();
			},
		});

		this._errorLbl = new Label({
			ParentNode: this._form,
			Class: 'label--error'
		});

		this._forgotPasswordBtn = new Button({
			ParentNode: this._form,
			RK: 'ILostMyPassword',
			Class: 'forgotPasswordBtn, app-button--black',
			EvClick: () =>
			{
				(new ResetPasswordDialog({
					AutoDestroy: true,
					Email: this._emailInput.getValue()
				}).show());
			}
		});

		this._btnDone = new Button({
			ParentNode: this._form,
			RK: 'SignIn',
			Class: 'app-button--unelevated app-button--raised app-button--login',
			EvClick: () => this._onSimpleReg()
		});


		if (NP.IsChrome)
		{
			this.addClass('login-panel--chrome-fixes');
		}

		// window.addEventListener('resize', () => RegistrationPanel.prototype.onWndResize.call(this));
		// RegistrationPanel.prototype.onWndResize.call(this);

		if (NP.getQueryParam('reset'))
			this._forgotPasswordBtn.EvClick.fire(this);
	}

	_onSimpleReg()
	{
		if (!this._request)
		{
			this._errorLbl.setContent("");
			this._request = NP.ajax({
				Url: "/login-actions/login",
				Data: JSON.stringify({
					user: this._emailInput.getValue(),
					pass: this._passwordInput.getValue()
				}),
				Headers: {
					'Content-Type': 'application/json;charset=utf-8'
				},
				Type: 'POST'
			})
				 .then(() =>
				 {

					 // if (this._emailInput.getValue() == 'judge' || this._emailInput.getValue() == 'v.kiselev' || this._emailInput.getValue() == 'e.lee' || this._emailInput.getValue() == 'a.kasatkin' || this._emailInput.getValue() == 'a.petrov')
						//  NP.loadTo(PageMode.mmaresults)
					 // else
						//  NP.loadTo(this._ReturnURL || (this._emailInput.getValue() == 'rccboxing' ? PageMode.boxresults : PageMode.mmaathletes))

					 window.location.href = '/';

				 })
				 .catch((response: any) =>
				 {
					 this._errorLbl.setIsVisible(true);
					 if (response.status === 502 || response.status === 0)
						 this._errorLbl.setContent(NP.RM.getString('ServerDownAuth'));
					 else if (response.status === 406)
						 this._errorLbl.setContent(response.data);
					 else if (response.status === 401)
						 this._errorLbl.setContent(S(response.data).escapeHTML().s || NP.RM.getString('InvalidEmailOrPassword'));
					 else
						 this._errorLbl.setContent(S(response.data.replace('java.sql.SQLException: ', '')).escapeHTML().s);

					 this._request = null;
				 })
		}
		return false;
	}
};